/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![UnsendIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAB1UlEQVR4nN1VTUsVYRSehMogkEzcBP2HaCNuhBC8MXM+JjhzzpXiupAL7VxpSDSb2vr1A9yJ9A/CZdI6gnZFIS1aJS5KI0HjnfuO3rzemeHKXeQDL8x7OOd5zvv1TBBcGgDbOyTdbo/VarXrwFZH0tfItgNk+0h6AGxfgWwT48RE5FolAWQ7duNkHqsA6bc83m24HGB9VFkgTdMBZF1rI/mCbCmi3ROR4SiqjzBP3wfSRST7fpqny662VADIVvz3IbI9LyoSkRvI+gLZjrJa1qVSgZycKJkqXbaHOycg/ZPVosWlAkA2X5U8B5Au+PqdZrN5NTiLwsOkf2/XeXCkyPaptVWWdAqQbne9KWxvq63CXvr8jaAfgDgZ81v8uS8CUSR3/ap/9UUgjh+P+jfxsy8CRDredYsi1odAthdRnXsVQNZnXQ+ZSNVfya1eyNOWxXx0HI6rI8G5IrCtE9VnexEA1qeFD+2M2HAYyp3K5LE9cDbu/YhKC5D1Q+b7ZHNBEFwpJCedQbbf3rpXK3WEbK9OHdIaeVxEhsJw+tZEozHY1sxuTl5o1x0isYXA+sb9B7I56VabGf5gfnI7i2MyCaxRcFEA20arW90F1vcicvPCpP8F/gKj7BOkBB12AgAAAABJRU5ErkJggg==)
 */
export const UnsendIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M3 2a1 1 0 0 0-1 1v6a1 1 0 0 0 1 1h6a1 1 0 0 0 0-2H5.07a8 8 0 1 1 13.29 8.86l-.01.01a7.97 7.97 0 0 1-1.9 1.78 1 1 0 0 0 1.1 1.67c.19-.12.36-.25.53-.38.7-.54 1.32-1.16 1.85-1.85l.01-.01A9.95 9.95 0 0 0 22 12 10 10 0 0 0 4 6V3a1 1 0 0 0-1-1ZM3.18 14.06a1 1 0 0 0-.61 1.27c.11.33.24.64.4.95a1 1 0 0 0 1.8-.86c-.12-.24-.22-.5-.32-.75a1 1 0 0 0-1.27-.61ZM5.33 18.12a1 1 0 0 0 .09 1.41c.51.45 1.07.85 1.67 1.18a1 1 0 0 0 .98-1.74 8.02 8.02 0 0 1-1.33-.95 1 1 0 0 0-1.41.1ZM14.17 20.8a1 1 0 0 0-1.12-.87 8.08 8.08 0 0 1-1.87.03 1 1 0 1 0-.2 1.99 10.1 10.1 0 0 0 2.32-.03 1 1 0 0 0 .87-1.13Z"
        className={colorClass}
      />
    </svg>
  );
};
